"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

// eslint-disable-next-line import/no-anonymous-default-export
var _default = function _default(pathName, title) {
  // Google Analytics Event
  var dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: 'VirtualPageview',
    virtualPagePath: pathName,
    virtualPageTitle: title
  });
};

exports["default"] = _default;